export default {"src":"/_next/static/media/process_icon_2.31dee09d.svg","height":69,"width":69};